<template>
  <div class="show-protocol-view-wrapper">
    <slot></slot>
  </div>
</template>

<script>
  import autosize from 'autosize'
  import 'select2'
  import 'select2/dist/js/i18n/es'
  import { mapMutations } from 'vuex'
  
  export default {
    components: {},
    data() {
      return {
        funders: [],
      }
    },
    methods: {
      ...mapMutations(['protocols/SET_PROTOCOL_FUNDERS']),
      
      showFinancingOptions(show) {
        if(!show) {
          $('.has-not').removeClass('d-none')
          $('.has').addClass('d-none')
        }
        else {
          $('.has-not').addClass('d-none')
          $('.has').removeClass('d-none')
        }
      },
      addFunder() {
        const $funder = $('#funder')
        const $budget = $('#budget')
        
        if($funder.validate() && $budget.validate()) {
          const funder = $funder.val()
          const budget = $budget.val()
          
          if(funder && budget) {
          
          }
        }
      },
    },
    mounted() {
      const vm = this
      
      /**
       * Set funders.
       */
      if(window.protocol) {
        if(window.protocol.funders) {
          this['protocols/SET_FUNDERS_BY_PROTOCOL']({
            protocol: window.protocol,
            funders: window.protocol.funders,
          })
        }
      }
      
      autosize($('textarea'))
      
      $('#add-funder').on('click', this.addFunder)
      
      this.showFinancingOptions($('input[name="has_financing"]:checked').val())
      
      $(() => {
        $('input[name="has_financing"]').on('change', function() {
          vm.showFinancingOptions($(this).val())
        })
        
        const $search = $('.search-select-funders')
        
        $search.select2({
          placeholder: 'Seleccione una financiadora',
          language: 'es',
          ajax: {
            url: '/api/v1/funders',
            dataType: 'json',
            language: 'es',
            headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            data(params) {
              return {
                q: params.term,
                page: params.page || 1,
              }
            },
            processResults(data, params) {
              params.page = params.page || 1
              
              return {
                results: data.data,
                pagination: {
                  more: (params.page * 10) < data.meta.total,
                },
              }
            },
          },
        })
        
        $('.form').validate({
          ignore: [],
          rules: {
            has_financing: {
              required: true,
              maxlength: 255,
            },
            other_means: {
              required: function() {
                return $('[name="has_financing"]:checked').val() === ''
              },
            },
            'funders[]': {
              required: function() {
                return $('[name="has_financing"]:checked').val() !== ''
              },
            },
            funders: {
              required: function() {
                return $('[name="has_financing"]:checked').val() !== ''
              }
            },
            budget: {
              required: function() {
                return $('[name="has_financing"]:checked').val() !== ''
              }
            },
          },
          messages: {
            has_financing: {
              required: 'Este campo es requerido.',
              maxlength: 'El texto no debe superar los 255 caracteres.',
            },
            other_means: {
              required: 'Este campo es requerido.',
            },
            'funders[]': {
              required: 'Es necesario agregar por lo menos una financiadora.',
            },
          },
          highlight: function(element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function(label, element) {
            label.addClass('invalid-feedback')
            label.insertAfter(element)
          },
          submitHandler(form) {
            form.submit()
          },
        })
      })
    },
  }
</script>
